import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';
import cn from 'classnames';

import { Button } from 'components/Button';
import { formatCurrency } from 'utils/formatCurrency';

import styles from './styles.module.scss';

const PaymentSubmitted = () => {
  const history = useHistory();
  const quickpayData = useSelector((state) => state.quickpay.data);
  const suggestAutopay = (quickpayData.autopays || []).length === 0;

  const goToScheduleAutopay = () => history.push('/quickpay/enroll-autopay');

  const renderFromAccount = () => {
    const allPaymentMethods = (quickpayData?.paymentAccounts || []).map((acc) => ({
      value: acc.accountId,
      title: `${(acc.accountType)} ${acc.category === 'bankcard' ? `xxxx-xxxx-xxxx-${acc.cardNumberLast4}` : `xxxx${acc.accountNumberLast4}`}`,
    }));
    const lastPaymentAccountId = quickpayData?.lastPayment?.paymentAccountId;
    if (!lastPaymentAccountId) return '-';
    const selectedMethod = allPaymentMethods.find((acc) => acc.value === lastPaymentAccountId);
    return selectedMethod?.title;
  };

  const applyDate = get(quickpayData, 'lastPayment.applyDate') ? moment(new Date(get(quickpayData, 'lastPayment.applyDate'))).format('MM/DD/YYYY').toString() : '-';
  const payedAmount = get(quickpayData, 'lastPayment.amount', 0) + get(quickpayData, 'lastPayment.fees', 0);

  return (
    <div className={cn(styles.quickpay, styles.paymentSubmitted)}>
      <div className={styles.content}>
        <h1>Thank you for your payment!</h1>
        <h1>Your payment has been submitted for processing</h1>
        <div className={cn(styles.paymentInfo, 'mt-2')}>
          <table>
            <tbody>
              <tr>
                <td>From Account</td>
                <td className={styles.paymentCell}>{renderFromAccount()}</td>
              </tr>
              <tr>
                <td>Date</td>
                <td>{applyDate}</td>
              </tr>
              <tr>
                <td>Amount</td>
                <td>
                  $
                  {formatCurrency(payedAmount, 2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={styles.stickyFooter}>
        {suggestAutopay ? (
          <div>
            <p>To make future payments easier, would you like to sign-up for AutoPay?</p>
            <Button
              color="primary"
              className="w-100 mt-1"
              onClick={goToScheduleAutopay}
            >
              SIGN UP FOR AUTOPAY
            </Button>
          </div>
        ) : (
          <p className="text-center d-block mb-4">
            For your security, please close this
            <br />
            browser session
          </p>
        )}
      </div>
    </div>
  );
};

export default PaymentSubmitted;
